import { render, staticRenderFns } from "./detailTeam.vue?vue&type=template&id=85728954&scoped=true"
import script from "./detailTeam.vue?vue&type=script&lang=ts"
export * from "./detailTeam.vue?vue&type=script&lang=ts"
import style0 from "./detailTeam.vue?vue&type=style&index=0&id=85728954&prod&lang=less&scoped=true"
import style1 from "./detailTeam.vue?vue&type=style&index=1&id=85728954&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85728954",
  null
  
)

export default component.exports